import { genericMemo } from '@direct-frontend/stdlib';
import { ElementTreeEditor } from './ElementTreeEditor';
import { type TreeEditorProps } from './types';
import { WindowTreeEditor } from './WindowTreeEditor';

export { type TreeEditorProps } from './types';

/**
 * Компонент отрисовки дерева с иерархией
 */
export const TreeEditor = genericMemo(function TreeEditor<Attributes = unknown>(props: TreeEditorProps<Attributes>) {
    if (props.isVirtualized && props.virtualizationMode === 'window') {
        return <WindowTreeEditor {...props} />;
    }

    return <ElementTreeEditor {...props} />;
});
